module.exports = __webpack_public_path__ + "img/Sokal_Creative-Analyisis_p2_icon-04.ed6e2845.png";